import api from './api';
import { Achievement, AchievementDefinition, AchievementProgress } from '../types/mundus';

export interface GetAvailableAchievementsResponse {
  success: boolean;
  data: {
    achievements: AchievementDefinition[];
    total: number;
  };
}

export interface GetMundusAchievementsResponse {
  success: boolean;
  data: {
    achievements: Achievement[];
    total: number;
  };
}

export interface GetAchievementProgressResponse {
  success: boolean;
  data: AchievementProgress;
}

export interface CheckAchievementsResponse {
  success: boolean;
  data: {
    newAchievements: Achievement[];
    count: number;
  };
}

/**
 * Get all available achievement definitions
 */
export const getAvailableAchievements = async (): Promise<AchievementDefinition[]> => {
  const response = await api.get<GetAvailableAchievementsResponse>('/api/achievements/available');
  return response.data.data.achievements;
};

/**
 * Get unlocked achievements for a Mundus
 */
export const getMundusAchievements = async (mundusId: string): Promise<Achievement[]> => {
  const response = await api.get<GetMundusAchievementsResponse>(`/api/achievements/mundus/${mundusId}`);
  return response.data.data.achievements;
};

/**
 * Get achievement progress for a Mundus
 */
export const getAchievementProgress = async (mundusId: string): Promise<AchievementProgress> => {
  const response = await api.get<GetAchievementProgressResponse>(`/api/achievements/mundus/${mundusId}/progress`);
  return response.data.data;
};

/**
 * Manually check/refresh achievements for a Mundus
 */
export const checkAchievements = async (mundusId: string): Promise<Achievement[]> => {
  const response = await api.post<CheckAchievementsResponse>(`/api/achievements/mundus/${mundusId}/check`);
  return response.data.data.newAchievements;
};
